<template>
  <SinglePage />
</template>

<script>
import SinglePage from '../../components/superAdmin/board/index.vue'
export default {
  components: { SinglePage },
}
</script>

<style></style>
